"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderLocation = exports.getWindsFormatted = exports.getMarkerStyle = exports.generateRouteFeatures = exports.generateRouteData = exports.getLocationData = exports.filterWaypoints = exports.convertCoordsToGeoJSON = exports.convertPointsToFeatures = exports.createPoint = exports.configureForecastRequest = exports.configureRouteRequest = exports.getMarkerOpts = exports.getPropForDataType = exports.getEndpointForDataType = void 0;

var _Feature = _interopRequireDefault(require("../../maps/geo/Feature"));

var _utils = require("../../utils");

var _math = require("../../utils/math");

var _number = require("../../utils/number");

var _strings = require("../../utils/strings");

var _units = require("../../utils/units");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var PROP_MAPPING = {
  temps: ['tempF', 'tempC'],
  dewpt: ['dewpointF', 'dewpointC'],
  feelslike: ['feelslikeF', 'feelslikeC'],
  winds: ['windSpeedMPH', 'windSpeedKPH'],
  windgusts: ['windGustMPH', 'windGustKPH'],
  humidity: ['humidity', 'humidity'],
  precip: ['precipIN', 'precipMM'],
  sky: ['sky', 'sky'],
  weather: ['weatherPrimary', 'weatherPrimary']
};

var getEndpointForDataType = function (type) {
  if (type === 'alerts') {
    return 'alerts';
  }

  return 'forecasts';
};

exports.getEndpointForDataType = getEndpointForDataType;

var getPropForDataType = function (type) {
  var endpoint = getEndpointForDataType(type);
  var result = PROP_MAPPING[type];

  if (result) {
    var prefix = '';

    if (endpoint === 'observations') {
      prefix = 'ob.';
    } else if (endpoint === 'forecasts' || endpoint === 'conditions') {
      prefix = 'periods.';
    }

    return "" + prefix + result[0];
  }

  if (endpoint === 'alerts') {
    return 'details.name,details.type,details.color,details.cat';
  }

  return '';
};

exports.getPropForDataType = getPropForDataType;

var getMarkerOpts = function (type) {
  switch (type) {
    case 'end':
    case 'start':
      return {
        fill: {
          color: '#222222'
        },
        stroke: {
          width: 4
        },
        size: [30, 30]
      };

    case 'current':
      return {
        fill: {
          color: '#ee6b00'
        },
        stroke: {
          width: 3
        },
        size: [22, 22]
      };

    default:
      return {
        fill: {
          color: '#222222'
        },
        stroke: {
          width: 2
        },
        size: [14, 14]
      };
  }
};

exports.getMarkerOpts = getMarkerOpts;

var configureRouteRequest = function (request, dataType, endpoint, points) {
  var dataProp = getPropForDataType(dataType);
  request.endpoint(endpoint);
  request.route(points.map(function (p) {
    var _a = (0, _utils.get)(p, 'geometry.coordinates'),
        lon = _a[0],
        lat = _a[1];

    var opts = dataType !== 'alerts' ? {
      from: (0, _utils.get)(p, 'properties.from')
    } : undefined;
    return __assign({
      p: lat + "," + lon
    }, opts);
  }));

  if (endpoint === 'forecasts') {
    var fields = ['temps', 'winds', 'windgusts', 'weather'].map(function (type) {
      return getPropForDataType(type);
    });
    request.fields(fields.join(',') + ",request.skipped,periods.dateTimeISO");
    request.filter('1min');
    request.plimit(1);
    request.mindist('10mi');
  } else if (endpoint === 'alerts') {
    request.fields(dataProp + ",request.skipped");
    request.limit(1);
    request.mindist('5mi');
  }
};

exports.configureRouteRequest = configureRouteRequest;

var configureForecastRequest = function (request, loc, timestamp) {
  var forecastFields = "\n\t\ttimestamp,dateTimeISO,tempF,tempC,icon,weatherPrimary,windSpeedMPH,windSpeedKPH,windSpeedMinMPH,windSpeedMinKPH,\n\t\twindSpeedMaxMPH,windSpeedMaxKPH,windGustMPH,windGustKPH\n\t".split(',').map(function (key) {
    return "periods." + key;
  });
  var dateParam = timestamp;

  if ((0, _utils.isNumber)(dateParam)) {
    dateParam = new Date(dateParam);
  }

  request.endpoint('forecasts').place(loc).fields(forecastFields.join(',')).filter('1hr').from(dateParam).limit(1);
  return {
    request: request,
    date: dateParam
  };
};

exports.configureForecastRequest = configureForecastRequest;

var createPoint = function (coord, properties) {
  if (properties === void 0) {
    properties = {};
  }

  return {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: coord
    },
    properties: properties
  };
};

exports.createPoint = createPoint;

var convertPointsToFeatures = function (points) {
  var features = points.map(function (point) {
    var featureType = (0, _utils.get)(point, 'type');

    if (point instanceof _Feature.default) {
      return point;
    }

    if ((0, _utils.isset)(featureType)) {
      if (featureType === 'Point' || featureType === 'Feature') {
        return new _Feature.default(point);
      }
    }

    if ((0, _utils.isArray)(point)) {
      var lon = point[0],
          lat = point[1];
      return new _Feature.default({
        type: 'Point',
        coordinates: [lon, lat]
      });
    }

    if ((0, _utils.isPlainObject)(point)) {
      if ((0, _utils.isValidCoord)(point)) {
        var lat = point.lat,
            lon = point.lon;
        return new _Feature.default({
          type: 'Point',
          coordinates: [lon, lat]
        });
      }
    }

    return null;
  });
  return features.filter(function (v) {
    return (0, _utils.isset)(v);
  });
};

exports.convertPointsToFeatures = convertPointsToFeatures;

var convertCoordsToGeoJSON = function (coords, distance, duration) {
  if (distance === void 0) {
    distance = 0;
  }

  if (duration === void 0) {
    duration = 0;
  }

  var totalDistance = 0;
  var points = coords.map(function (coord, i) {
    var progress = 0;

    if (distance > 0) {
      if (i === coords.length - 1) {
        progress = 1;
      } else if (i > 0) {
        var lastCoord = coords[i - 1];
        totalDistance += (0, _math.geoDistance)(coord, lastCoord);
        progress = totalDistance / distance;
      }
    }

    return {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [coord.lon, coord.lat]
      },
      properties: {
        from: "+" + Math.round(duration * progress / 60) + "minutes"
      }
    };
  });
  return {
    points: points,
    distance: totalDistance
  };
};

exports.convertCoordsToGeoJSON = convertCoordsToGeoJSON;

var filterWaypoints = function (waypoints, startCoord, endCoord) {
  return waypoints.filter(function (waypoint) {
    var lat;
    var lon;
    var unique = true;

    if ((0, _utils.isArray)(waypoint)) {
      lat = waypoint[1];
      lon = waypoint[0];
    } else if (waypoint instanceof _Feature.default) {
      var coord = waypoint.geometry.toArray(true);
      lat = coord[1];
      lon = coord[0];
    } else if ((0, _utils.isPlainObject)(waypoint)) {
      lat = waypoint.lat;
      lon = waypoint.lon;
    }

    if (startCoord) {
      if (lon === startCoord[0] && lat === startCoord[1]) {
        unique = false;
      }
    }

    if (endCoord) {
      if (lon === endCoord[0] && lat === endCoord[1]) {
        unique = false;
      }
    }

    return unique;
  });
};

exports.filterWaypoints = filterWaypoints;

var getLocationData = function (point, place) {
  if (!(0, _utils.isArray)(point) || point.length < 2) {
    return undefined;
  }

  var coord = {
    lat: point[1],
    lon: point[0]
  };
  var id = coord.lat + "_" + coord.lon;

  if (!place) {
    place = {
      lat: point[1],
      lon: point[0]
    };
  }

  return {
    id: id,
    place: (0, _utils.isPlainObject)(place) ? (0, _number.formatNumber)(place.lat, 4) + ", " + (0, _number.formatNumber)(place.lon, 4) : (0, _strings.toName)(place),
    loc: coord
  };
};

exports.getLocationData = getLocationData;

var generateRouteData = function (config, points) {
  var configPoints = config.points || [];
  var startCoord = points[0];
  var endCoord = points[points.length - 1];
  var waypoints = (0, _utils.get)(config, 'data.waypoints') || configPoints.filter(function (v, i) {
    return i !== 0 && i < configPoints.length - 1;
  });
  var departure = (0, _utils.isset)(configPoints[0]) ? configPoints[0] : undefined;
  var destination = configPoints.length > 0 ? configPoints[configPoints.length - 1] : undefined;
  departure = (0, _utils.get)(config, 'data.departure.place') || departure;
  destination = (0, _utils.get)(config, 'data.destination.place') || destination;
  return (0, _utils.extend)({
    departure: {
      title: (0, _utils.get)(config, 'data.departure.title') || 'Departure',
      place: departure
    },
    destination: {
      title: (0, _utils.get)(config, 'data.destination.title') || 'Destination',
      place: destination
    }
  }, config.data, {
    departure: getLocationData(startCoord, departure),
    destination: getLocationData(endCoord, destination),
    waypoints: filterWaypoints(waypoints, startCoord, endCoord).map(function (waypoint) {
      if (waypoint instanceof _Feature.default) {
        var coord = waypoint.geometry.toArray(true);
        var name_1 = (0, _utils.get)(waypoint.properties, 'name');
        return getLocationData(coord, name_1);
      }

      return getLocationData(undefined, waypoint);
    })
  });
};

exports.generateRouteData = generateRouteData;

var generateRouteFeatures = function (routeId, points, routeData) {
  var features = [];
  var startCoord;
  var endCoord;

  if ((0, _utils.isArray)(points)) {
    var currentFeature_1;

    var addFeature_1 = function () {
      features.push({
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: currentFeature_1.coords
        },
        properties: __assign(__assign({}, currentFeature_1.data), {
          routeId: routeId
        })
      });
    };

    var resetFeature_1 = function (coord, apiData) {
      currentFeature_1 = {
        data: apiData,
        coords: [coord]
      };
    };

    if (points.length > 1) {
      startCoord = (0, _utils.get)(points[0], 'geometry.coordinates');
      endCoord = (0, _utils.get)(points[points.length - 1], 'geometry.coordinates'); // add points for route markers

      var startFeature = createPoint(startCoord, {
        type: 'start',
        label: 'A',
        routeId: routeId,
        coordinate: {
          lat: startCoord[1],
          lon: startCoord[0]
        }
      });
      var endFeature = createPoint(endCoord, {
        type: 'end',
        label: 'B',
        routeId: routeId,
        coordinate: {
          lat: endCoord[1],
          lon: endCoord[0]
        }
      });
      features.push(startFeature, endFeature); // add line segments

      points.forEach(function (point, index) {
        var coord = (0, _utils.get)(point, 'geometry.coordinates');
        var skipped = (0, _utils.get)(point, 'properties.request.skipped');
        var apiResponse = (0, _utils.get)(point, 'properties.response');

        if (index === 0) {
          resetFeature_1(coord, apiResponse);
        } else {
          currentFeature_1.coords.push(coord);

          if (index > 0 && !skipped || index === points.length - 1) {
            addFeature_1();
            resetFeature_1(coord, apiResponse);
          }
        }
      });
    }
  } // add points for route markers and waypoints


  if (routeData) {
    var waypoints = routeData.waypoints,
        current = routeData.current;

    if (waypoints) {
      var filteredWaypoints = filterWaypoints(waypoints, startCoord, endCoord);
      filteredWaypoints.forEach(function (waypoint, index) {
        if (waypoint instanceof _Feature.default) {
          var _a = waypoint.geometry.toArray(true),
              lon = _a[0],
              lat = _a[1];

          features.push(createPoint([lon, lat], {
            type: 'waypoint',
            routeId: routeId,
            coordinate: {
              lat: lat,
              lon: lon
            },
            index: index
          }));
        }
      });
    }

    if (current && current.loc) {
      var _a = current.loc || {},
          lat = _a.lat,
          lon = _a.lon;

      if ((0, _utils.isset)(lat) && (0, _utils.isset)(lon)) {
        features.push(createPoint([lon, lat], {
          type: 'current',
          routeId: routeId,
          coordinate: {
            lat: lat,
            lon: lon
          }
        }));
      }
    }
  }

  return features;
};

exports.generateRouteFeatures = generateRouteFeatures;

var getMarkerStyle = function (modelData, routeData) {
  var type = modelData.type,
      label = modelData.label;
  var markerOpts = getMarkerOpts(type); // use a custom marker style for this waypoint if defined

  var markerStyle = (0, _utils.get)(routeData, type + ".markerStyle");

  if (markerStyle) {
    return __assign({}, markerStyle);
  }

  return {
    className: 'marker-route-waypoint',
    svg: {
      shape: (0, _utils.extend)({
        type: 'circle',
        fill: {
          color: '#222222'
        },
        stroke: {
          color: '#ffffff',
          width: 2
        },
        size: [14, 14]
      }, markerOpts),
      text: label ? {
        value: label,
        anchor: 'start',
        color: '#ffffff',
        translate: {
          y: -2
        },
        autosize: false
      } : undefined
    },
    size: markerOpts.size || [14, 14]
  };
};

exports.getMarkerStyle = getMarkerStyle;

var getWindsFormatted = function (data, metric) {
  if (metric === void 0) {
    metric = false;
  }

  var result = 'Calm';

  if (data.windSpeedMaxMPH > 5) {
    if (metric) {
      result = (0, _utils.toRangeStr)(data.windSpeedMinKPH, data.windSpeedMaxKPH, 5) + " " + (0, _units.unitsForDataType)('speed', true);
    } else {
      result = (0, _utils.toRangeStr)(data.windSpeedMinMPH, data.windSpeedMaxMPH, 5) + " " + (0, _units.unitsForDataType)('speed', false);
    }
  } else if (data.windSpeedMaxMPH < 5 && data.windSpeedMinMPH > 0) {
    result = metric ? '< 8 kmh' : '< 5 mph';
  }

  return result;
};

exports.getWindsFormatted = getWindsFormatted;

var renderLocation = function (type, data, includesDuration) {
  if (includesDuration === void 0) {
    includesDuration = true;
  }

  var weather = data.weather,
      _a = data.metric,
      metric = _a === void 0 ? false : _a,
      _b = data.selected,
      selected = _b === void 0 ? false : _b,
      loc = data.loc;
  var dataAttr = ["data-waypoint-type=\"" + data.type + "\""];

  if ((0, _utils.isset)(loc)) {
    dataAttr.push("data-coord=\"" + loc.lat + "," + loc.lon + "\"");
  }

  if (type === 'waypoint') {
    return "\n\t\t\t<div class=\"awxjs__routing-waypoint" + (selected ? ' awxjs__routing-location-selected' : '') + "\">\n\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t<div class=\"awxjs__routing-marker\">\n\t\t\t\t\t\t<div class=\"awxjs__routing-marker-connector\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"awxjs__routing-location-info\">\n\t\t\t\t\t\t<div class=\"awxjs__text-md awxjs__text-bold\">\n\t\t\t\t\t\t\t" + data.place + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t";
  }

  return "\n\t\t<div class=\"awxjs__routing-location" + (selected ? ' awxjs__routing-location-selected' : '') + "\">\n\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t<div class=\"awxjs__routing-marker\">\n\t\t\t\t\t<div class=\"awxjs__routing-marker-outer\"></div>\n\t\t\t\t\t<div class=\"awxjs__routing-marker-inner\"></div>\n\t\t\t\t\t<div class=\"awxjs__routing-marker-label\">" + (data.indicator || '') + "</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"awxjs__routing-location-info awxjs__expand\">\n\t\t\t\t\t<div class=\"awxjs__ui-cols\">\n\t\t\t\t\t\t<div class=\"awxjs__expand\">\n\t\t\t\t\t\t\t<div class=\"awxjs__text-lg awxjs__text-bold\">\n\t\t\t\t\t\t\t\t" + data.title + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"awxjs__text-md\">\n\t\t\t\t\t\t\t\t" + data.place + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t" + (includesDuration ? "\n\t\t\t\t\t\t\t\t<div class=\"awxjs__text-md awxjs__push-top\">\n\t\t\t\t\t\t\t\t\t" + data.timeLabel + ":&nbsp;\n\t\t\t\t\t\t\t\t\t<strong>" + (0, _utils.formatDate)(new Date(data.timestamp), 'h:mm a, MMM d, yyyy') + "</strong>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t" : '') + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t" + ((0, _utils.isset)(loc) ? "\n\t\t\t\t\t\t\t<div class=\"awxjs__right\">\n\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-btn-icon awxjs__ui-btn-icon-filled awxjs__ui-btn-goto\" " + dataAttr.join(' ') + " title=\"Zoom to location\">\n\t\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 100\">\n\t\t\t\t\t\t\t\t\t\t<path d=\"M50,0C30.9,0,15.6,15.3,15.6,34.4C15.6,53.4,50,100,50,100s34.4-46.6,34.4-65.6C84.4,15.3,69.1,0,50,0z M50,50\n\t\t\t\t\t\t\t\t\t\t\tc-8.7,0-15.6-6.9-15.6-15.6c0-8.7,6.9-15.6,15.6-15.6c8.7,0,15.6,6.9,15.6,15.6C65.6,43.1,58.7,50,50,50z\"/>\n\t\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t" : '') + "\n\t\t\t\t\t</div>\n\t\t\t\t\t" + (weather ? "\n\t\t\t\t\t\t<div class=\"awxjs__routing-location-wx\">\n\t\t\t\t\t\t\t<div class=\"awxjs__ui-cols align-center\">\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<img class=\"awxjs__app__ui-panel-info__forecast-icon\" src=\"https://cdn.aerisapi.com/wxblox/icons/" + (weather.icon || 'na.png') + "\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__forecast-temp\">\n\t\t\t\t\t\t\t\t\t" + (0, _units.formatDataValue)(weather, 'tempF', 'tempC', metric) + "\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__forecast-conditions\">\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__forecast-wx\">\n\t\t\t\t\t\t\t\t\t\t" + weather.weatherPrimary + "\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__forecast-detail\">\n\t\t\t\t\t\t\t\t\t\t<span>Winds</span> " + getWindsFormatted(weather, metric) + "\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t" : '') + "\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t";
};

exports.renderLocation = renderLocation;